import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { TaskTypeService, TaskTypes } from './task-type.service';
import { MatSelectChange } from '@angular/material/select';
import { BlahService } from '@headpower/blah-ng';

@Component({
  selector: 'app-tasktype-select',
  templateUrl: './task-type-select.component.html'
})
export class TaskTypeSelectComponent implements OnChanges {
  @Input() value: string;
  @Input() placeholder: string = '';
  @Input() class: string;
  @Input() multiple: boolean = false;
  @Input() displayAllTaskTypes: boolean = false;
  @Input() showDefault: boolean = false;

  @Output() valueChange = new EventEmitter();

  public taskTypes: Array<string>;

  constructor(private taskTypeService: TaskTypeService,
    private blahService: BlahService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.displayAllTaskTypes &&
      (changes.displayAllTaskTypes.isFirstChange || changes.displayAllTaskTypes.previousValue !== changes.displayAllTaskTypes.currentValue)
    ) {
      this.getTaskTypes();
    }
  }

  public getTaskTypes() {
    let method = this.displayAllTaskTypes ?
      this.taskTypeService.getAllTaskTypes() :
      this.taskTypeService.getTaskTypes();

    method.subscribe((result) => {
      let orderedResult = result.sort((a, b) => { return this.blahService.blah('task.taskType.' + a).localeCompare(this.blahService.blah('task.taskType.' + b)) });
      this.taskTypes = orderedResult;
    });
  }

  public change(change: MatSelectChange) {
    const selected = change.value;
    this.valueChange.emit(selected);
  }

}
